import Cookies from 'js-cookie';
import gitShaVersion from './gitShaVersion';

/**
 * This is a slimmed down version of the full apiFetch specifically to be used
 * in the pubsub worker iframe. It only works client-side.
 */
const apiFetch = (url: string, initOptions: RequestInit) => fetch(
  `/api/v4${url}`,
  {
    ...initOptions,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
      ...gitShaVersion,
      ...initOptions.headers,
    } as Record<string, string>,
  },
);

export default apiFetch;
